var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMtnLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 529.134,
    height: 264.567,
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 4950.37 2475.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2475.19 0C1108.19 0 0 554.1 0 1237.59c0 683.5 1108.19 1237.59 2475.19 1237.59s2475.19-554.1 2475.19-1237.59C4950.38 554.09 3842.19 0 2475.19 0zm0 2279.8c-1259.1 0-2279.8-466.61-2279.8-1042.21S1216.1 195.38 2475.19 195.38c1259.1 0 2279.8 466.61 2279.8 1042.21S3734.28 2279.8 2475.19 2279.8zm-312.15-1259.33V825.05h698.28v195.42h-251.39v629.66h-195.46v-629.66h-251.43zm1541.15-195.42v825.09h-195.38l-354.38-491.17v491.17h-195.39V825.05h195.38l354.38 491.17V825.05h195.39zm-2463.82 825.09V825.05h195.39l217.08 333.92 217.08-333.92h195.31v825.09h-195.31v-466.69l-148.2 227.8h-137.76l-148.2-227.8v466.69h-195.39z",
    style: {
      fill: "#000",
      fillRule: "nonzero"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtnLogo);
export default __webpack_public_path__ + "static/media/MTNLogo.f290098f28923488356c75e363a37194.svg";
export { ForwardRef as ReactComponent };